import { EventBus } from 'quasar'

export default async ({ app }) => {
  const emitter = new EventBus()
  app.config.globalProperties.emitter = emitter
}
